import { AxiosResponse } from "axios"
import { axiosInstance, MessageResponse } from "./common"

export enum CaseNoteType {
    case_details = "case_details",
    profile_verification = "profile_verification",
    portfolio_analysis = "portfolio_analysis",
    interview_findings = "interview_findings",
    collateral_verification = "collateral_verification",
    additional_analysis = "additional_analysis"
}

export interface CaseNote {
    case_id?: string
    type: CaseNoteType
    value: string
    ai_generated: boolean
    user_updated: boolean
    data_used?: {[key: string]: any}
    created_at?: string
    version?: number
}

export interface UpdateCaseNoteRequest {
    value: string
    ai_generated?: boolean
    user_updated: boolean
    data_used?: boolean
}

const CaseNoteAPI = {
    create: async (caseNote: CaseNote) => {
        const response: AxiosResponse<MessageResponse> = await axiosInstance.post('/v1/case-notes', caseNote);
        return response.data;
    },

    upsert: async (caseId: string, type: string, request: UpdateCaseNoteRequest) => {
        const response: AxiosResponse<MessageResponse> = await axiosInstance.put(`/v1/case-notes/${caseId}/type/${type}`, request);
        return response.data;
    }
}

export default CaseNoteAPI;